// extracted by mini-css-extract-plugin
export default {"categoryContainer":"index_topmenu_categoryContainer__w3Zzh","active":"index_topmenu_active__AWQ7N","image":"index_topmenu_image__ixB7X","title":"index_topmenu_title__ZlIf3"};